export default [
  {
    path: '/Personal/Spread',
    component: () => import('@/views/PersonalCenter/Spread/Index'),
    name: 'Spread',
    meta: {
      title: '我的推广',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Call',
    component: () => import('@/views/PersonalCenter/Call/Index'),
    name: 'Call',
    meta: {
      title: '通话记录',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Spread/InviteCode',
    component: () => import('@/views/PersonalCenter/Spread/InviteCode'),
    name: 'InviteCode',
    meta: {
      title: '邀请码',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Spread/MoneyExtract',
    component: () => import('@/views/PersonalCenter/Spread/MoneyExtract'),
    name: 'MoneyExtract',
    meta: {
      title: '提现',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Spread/MoneyWithdraw',
    component: () => import('@/views/PersonalCenter/Spread/MoneyWithdraw'),
    name: 'MoneyWithdraw',
    meta: {
      title: '提现记录',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Spread/RuleMoney',
    component: () => import('@/views/PersonalCenter/Spread/RuleMoney'),
    name: 'RuleMoney',
    meta: {
      title: '佣金规则',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  }
]
